import { useAtomCallback } from "jotai/utils";
import { toast } from "../../toasts";
import { isScreenShareModeAtom } from "../../video-sdk/twilio";
import { isWhiteboardModeAtom } from "../messages/state";
import useScreenShareCallbacks, {
  ShareScreenOptions,
} from "./useScreenShareCallbacks";
import { useWhiteboardCallbacks } from "./useWhiteboardCallbacks";

type SwitchToMode = (
  ...args:
    | ["screenshare", ShareScreenOptions]
    | ["screenshare"]
    | ["whiteboard"]
) => void;

export function useSessionModeCallbacks() {
  const getIsScreenshareMode = useAtomCallback((get) =>
    get(isScreenShareModeAtom),
  );
  const getIsWhiteboardMode = useAtomCallback((get) =>
    get(isWhiteboardModeAtom),
  );

  const { startWhiteboard, stopWhiteboard } = useWhiteboardCallbacks();
  const { triggerBrowserScreenShare, stopScreenShare } =
    useScreenShareCallbacks(() => {
      toast.error("There was an error sharing your screen");
    });

  function stopCurrentMode() {
    if (getIsScreenshareMode()) {
      stopScreenShare();
    } else if (getIsWhiteboardMode().value) {
      stopWhiteboard();
    }
  }

  const switchToMode: SwitchToMode = (mode, options?) => {
    stopCurrentMode();
    switch (mode) {
      case "screenshare": {
        triggerBrowserScreenShare(options);
        break;
      }
      case "whiteboard": {
        startWhiteboard();
        break;
      }
    }
  };

  return {
    switchToMode,
    stopCurrentMode,
  };
}
